import * as localizedActions from './localized/actions'
import * as progressActions from './progress/actions'
import * as serverActions from './serverNames/actions'
import * as steamActions from './steam/actions'
import * as versionActions from './versions/actions'

// eslint-disable-next-line
export const actions = {
    localized: localizedActions,
    progress: progressActions,
    serverNames: serverActions,
    steam: steamActions,
    versions: versionActions,
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/actions.js